import { render, staticRenderFns } from "./liveSatis.vue?vue&type=template&id=2d049a8e&scoped=true"
import script from "./liveSatis.vue?vue&type=script&lang=js"
export * from "./liveSatis.vue?vue&type=script&lang=js"
import style0 from "./liveSatis.vue?vue&type=style&index=0&id=2d049a8e&prod&lang=scss&scoped=true"
import style1 from "./liveSatis.vue?vue&type=style&index=1&id=2d049a8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d049a8e",
  null
  
)

export default component.exports